import type { ITabItem } from 'components/Form';
import { TabsIds } from 'pages/Project/Common/types';
import { contractTabs } from 'pages/Project/Common/utils';

import { useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

export const useTabs = () => {
    const { tabId = TabsIds.COMMON } = useParams();

    const initialActiveTab = useMemo(
        () =>
            contractTabs.find(({ id }) => String(id).toUpperCase() === String(tabId).toUpperCase()) ?? contractTabs[0],
        [tabId],
    );

    const [activeTab, setActiveTab] = useState<ITabItem<TabsIds>>(initialActiveTab);

    const handleTabChange = useCallback(({ value }) => setActiveTab(value), [setActiveTab]);

    return {
        activeTab,
        handleTabChange,
    };
};
